import { render, staticRenderFns } from "./mainHelpDesk.vue?vue&type=template&id=58fa1303"
import script from "./mainHelpDesk.vue?vue&type=script&lang=js"
export * from "./mainHelpDesk.vue?vue&type=script&lang=js"
import style0 from "./mainHelpDesk.vue?vue&type=style&index=0&id=58fa1303&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports